import { render } from "./RejectedRequests.vue?vue&type=template&id=1ff2bb9a"
import script from "./RejectedRequests.vue?vue&type=script&lang=js"
export * from "./RejectedRequests.vue?vue&type=script&lang=js"

import "./RejectedRequests.vue?vue&type=style&index=0&id=1ff2bb9a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__